module.exports = "<h1>\r\n    {{file}}\r\n</h1>\r\n\r\n<markdown class=\"markdown\" [path]=\"mdurl\"></markdown>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/view/view.component.html
// module id = ./src/app/components/view/view.component.html
// module chunks = main